/**
 * Client für die Themen der Demo-Buchung (/administration/demo-topics auf tri-server, nur Plattform-Root).
 * Siehe tri-server docs/demo-booking.md.
 */
import { configuration } from "./Configuration";
import { ApplicationError, UnauthorizedError } from "./general/Errors";
import { authenticatedFetch } from "./JWTAuthService";

export interface DemoTopic {
  key: string;
  title: string;
  description?: string | null;
  hosts: string[];
  active: boolean;
  minNoticeHours?: number;
  horizonDays?: number;
  /** Länge einer Vorführung in Minuten; längere Demo-Slots werden geteilt. */
  slotMinutes?: number;
  updatedAt?: string;
  updatedBy?: string | null;
}
export interface DemoSlot {
  id: string;
  start: string;
  end: string;
  host: string;
}

const processResponse = async (response: Response) => {
  if (response.ok) return response.json();
  if (response.status === 401) throw new UnauthorizedError();
  let message = `${response.status} ${response.statusText}`;
  try {
    const body = await response.json();
    message = body.message || body.error || message;
  } catch {
    // kein JSON
  }
  throw new ApplicationError(message);
};

export const useDemoBookingAPI = () => {
  const base = `${configuration.serverUrl}/administration/demo-topics`;
  const call = async (path: string, init: RequestInit = {}) =>
    processResponse(await authenticatedFetch(`${base}${path}`, { ...init, headers: { "Content-Type": "application/json" } }));
  return {
    listTopics: (): Promise<DemoTopic[]> => call(""),
    saveTopic: (topic: DemoTopic): Promise<DemoTopic> => call(`/${encodeURIComponent(topic.key)}`, { method: "PUT", body: JSON.stringify(topic) }),
    deleteTopic: (key: string): Promise<{ deleted: boolean }> => call(`/${encodeURIComponent(key)}`, { method: "DELETE" }),
    slots: (key: string): Promise<DemoSlot[]> => call(`/${encodeURIComponent(key)}/slots`),
  };
};
